import t from '@jetshop/intl';
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuItem,
  DropdownMenuItems,
} from '@jetshop/ui/DropdownMenu';
import React, { useContext } from 'react';
import styled, { css, cx } from 'react-emotion';
import { ReactComponent as Carot } from '../../svg/Carrot.svg';
import { ReactComponent as Check } from '../../svg/Check.svg';
import { theme } from '../Theme';
import ChannelContext from '@jetshop/core/components/ChannelContext';

export function VariantSelector({
  product,
  variantHandler,
  showValidation,
  disableOutOfStock,
  dropDownSelect,
}) {
  return (
    <div className={sharedStyles}>
      {product.variants.options.map((option) => {
        let showValidationMessage = false;
        if (
          showValidation &&
          variantHandler.getMissingOptions()?.includes(option)
        ) {
          showValidationMessage = true;
        }

        return (
          <>
            {dropDownSelect ? (
              <DropdownVariantSelect
                key={option.name}
                option={option}
                variantHandler={variantHandler}
                showValidationMessage={showValidationMessage}
              />
            ) : (
              <ButtonVariantSelect
                key={option.name}
                option={option}
                variantHandler={variantHandler}
                showValidationMessage={showValidationMessage}
              />
            )}
          </>
        );
      })}
    </div>
  );
}

const sharedStyles = css`
  label {
    display: block;
    padding-bottom: 0.25em;
    margin-top: 1em;
    font-size: 0.875em;
  }

  li {
    use {
      fill: black;
    }
    &:focus,
    &:hover {
      outline: none;
    }
    &:hover {
      font-weight: bold;
      color: black !important;
    }
  }
`;
const VariantStock = styled('div')`
  color: red;
  ${({ theme }) => theme.below.md} {
    font-size: 0.9rem;
  }
  ${({ theme }) => theme.below.md} 
    font-size: 0.9rem;
  }
  &.buyable {
    color: green;
  }
`;

const StyledButton = styled('button')`
  color: #000;
  background: #fff;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  height: 40px;
  line-height: 24px;
  min-width: 90px;
  padding: 0 20px;
  width: auto;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-top: 10px;
  margin-right: 10px;

  &.active-ski {
    background: ${(props) =>
      props.active ? theme.colors.black : theme.colors.skiAccent};
    color: #fff;
    font-weight: 700;
  }
  &.active-mtb {
    background: ${(props) =>
      props.active ? theme.colors.black : theme.colors.mtbAccent};
    color: #fff;
    font-weight: 700;
  }
  svg {
    margin-right: 0.5rem;
  }

  &.out-of-stock {
    color: #b3b3b3;
    text-decoration: line-through;
  }
`;

const ButtonSelectWrapper = styled('div')`
  display: flex;
  /* overflow-x: scroll; */
  /* overflow-x: auto; */
  padding-bottom: 14px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    background-color: #e3e3e3;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 2px;
    border-radius: 2px;
    background: #c0c0c0;
  }
`;

function ButtonVariantSelect({ option, variantHandler, preselected = null }) {
  const {
    getSelectedValue,
    validateSelection,
    selectValue,
    getVariantForSelection,
  } = variantHandler;
  const selectedValue = getSelectedValue(option);
  let title = false;
  if (option.name.toLowerCase().indexOf('storlek') > -1) {
    title = 'Storlek';
  } else if (option.name.toLowerCase().indexOf('längd') > -1) {
    title = 'Längd';
  }

  if (preselected) {
    selectValue(option.values[0], option);
  }

  const { selectedChannel } = useContext(ChannelContext);

  return (
    <>
      <ButtonSelectWrapper className="button-select-wrapper">
        {option.values.map((value) => {
          const validation = validateSelection(value, option);
          return (
            <StyledButton
              data-testid={option.name + value}
              key={option.name + value}
              onClick={() => selectValue(value, option)}
              className={cx(
                validation === 'outOfStock' ? 'out-of-stock' : 'in-stock',
                value === selectedValue
                  ? selectedChannel?.id === 1
                    ? 'active-ski'
                    : 'active-mtb'
                  : ''
              )}
              secondary={value !== selectedValue}
              aria-pressed={value === selectedValue}
            >
              {value}
            </StyledButton>
          );
        })}
      </ButtonSelectWrapper>
    </>
  );
}

function DropdownVariantSelect({ option, variantHandler, preselected = null }) {
  const {
    getSelectedValue,
    validateSelection,
    selectValue,
    getVariantForSelection,
  } = variantHandler;
  const selectedValue = getSelectedValue(option);
  let title = false;
  if (option?.name?.toLowerCase().indexOf('storlek') > -1) {
    title = 'Storlek';
  } else if (option?.name?.toLowerCase().indexOf('längd') > -1) {
    title = 'Längd';
  }

  if (preselected) {
    selectValue(option.values[0], option);
  }

  return (
    <div className={dropdownStyles}>
      {/* <label htmlFor={`option-${option.name}`}>{title ? title : option.name}</label> */}
      <DropdownMenu>
        <DropdownMenuButton
          disabled={option.values.length <= 0}
          id={`option-${option.name}`}
        >
          {selectedValue
            ? (title ? title : option.name) + ' ' + selectedValue
            : t.rich('Select {option}', {
                option: title ? title : option.name,
              })}
          <Carot />
        </DropdownMenuButton>
        <DropdownMenuItems style={{ zIndex: 9999 }}>
          {option.values.map((value) => {
            const validation = validateSelection(value, option);
            const variant = getVariantForSelection(value, option);
            return (
              <DropdownMenuItem
                key={value + option.name}
                disabled={validation === 'invalid'}
                onSelect={({ setIsOpen }) => {
                  selectValue(value, option);
                  setIsOpen(false);
                }}
                style={{ opacity: validation === 'invalid' ? 0.5 : 1 }}
              >
                <div>{value}</div>
                <div>
                  {selectedValue === value && <Check />}
                  {variant?.stockStatus && (
                    <VariantStock
                      className={variant.stockStatus.buyable && 'buyable'}
                    >
                      {variant.stockStatus.text}
                    </VariantStock>
                  )}
                </div>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuItems>
      </DropdownMenu>
    </div>
  );
}

const dropdownStyles = css`
  margin-top: 10px;
  [data-flight-dropdown] {
    background: white;
  }
  [data-flight-dropdown-button] {
    background: white;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
    font-weight: bold;
  }
  [data-flight-dropdown-open='true'] {
    [data-flight-dropdown-button] {
      border-bottom-color: transparent;
      border-radius: 3px 3px 0 0;
    }
  }
  [data-flight-dropdown-items] {
    width: 100%;
    border: 1px solid #e0e0e0;
    margin-top: -1px;
    border-radius: 0 0 3px 3px;
  }
  [data-flight-dropdown-item] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
      svg {
        margin-right: 5px;
      }
    }
    :last-child {
      border-radius: 0 0 3px 3px;
    }
  }
  svg {
    margin-left: auto;
  }
`;
